import Moment from 'moment'
import * as Redux from 'redux'
import * as Sortable from '../../components/sortable'
import * as Request from '../../request'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'

const emptyViewState: Types.IntegrationReportsViewState = {
  isFetching: false,
}

const normalizeTypes: Sortable.TypeNormalizer<Types.Report> =
  (payload: any): Sortable.SortableData<Types.Report> => {

  return payload.results.map((report: Types.Report) => ({
    ...report,
    end_date_time: Moment(report.end_date_time),
    start_date_time: Moment(report.start_date_time),
  }))
}

type RequestActions = Request.RequestAction<any> & Request.SuccessAction<any>

export const dataReducer =
  (state: Types.Report[] = [], action: RequestActions) => {
  switch (action.type) {
    case Request.successConstant(Constants.FETCH_RUN_DETAILS):
      return action.payload.response.results
    default:
      return state
  }
}

export const viewReducer =
  (state: any = emptyViewState, action: Actions.FetchRunDetailsAction) => {
  switch (action.type) {
    case Request.requestConstant(Constants.FETCH_RUN_DETAILS):
      return {
        ...state,
        isFetching: true,
      }
    case Request.successConstant(Constants.FETCH_RUN_DETAILS):
    case Request.errorConstant(Constants.FETCH_RUN_DETAILS):
      return {
        ...state,
        isFetching: false,
      }
    default:
      return state
  }
}

const reducerEvent: Sortable.ReducerEvent<Types.Report> = {
  defaultSort: {field: 'end_date_time', dir: 'desc'},
  normalizer: normalizeTypes,
  requestEvent: Constants.FETCH_RUN_DETAILS,
}

export const reducer = Redux.combineReducers({
  data: Sortable.stateReducer(reducerEvent),
  view: viewReducer,
})



// WEBPACK FOOTER //
// ./src/pages/integration-reports/reducer.tsx